module.exports = __webpack_public_path__ + "img/number item.9ed06637.svg";